import { Box, Button, Dialog, Drawer, Grid, IconButton, InputAdornment, Menu, MenuItem, Modal, Skeleton, TextField, Theme, Typography, useTheme } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { CustomeButton } from '../../../lib/formik/NewFormInputs';
import { BlueDropDownIcon, CrossIcon, DialogCloseIcon, FilterIcon, GreyDropDown, SearchIcon, YellowWarning } from '../../../assets/SvgIcons';
import { Order, PaginationObj, SortingObj, TableBodyData, TableHeaderData } from '../types';
import CustomTable from './customTable';
import MutualFundTableBody from './customTable/MutualFundTableBody';
import { HoldingModalTableBody, HoldingSearchFundTable, InvestmentSearchTable } from '../mutualFund/common/Table';
import { useDispatch, useSelector } from 'react-redux';
import { getAmcFilters, getHoldingsData, getRiskFilters, getSearchSchemesTableData, setAppliedHoldingsFilters, setCheckedHoldingSchemes, setHoldingsActiveCategory, setSelectedAllHoldingsInfo, setSelectedHoldingsIds, setSelectedHoldingsInfo, setSelectedSchemesObj } from '../../../redux-store/actions/investorProfile';
import { useDebounce } from '../../../utils/useDebounce';
import { AmcFilter, AppliedHoldingsFilters, GetHoldingsDataResponseBody, GetSearchSchemesTableDataResponseBody, RiskFilter } from '../../../redux-store/types/investorProfile';
import { useHistory } from 'react-router';
import FiveSchemesDialog from '../exploreMutualFund/FiveSchemesDialog';
import { RootStateType } from '../../../redux-store/reducers';
import Holdings from '../mutualFund/holdings';
import { FetchHoldingsData, HoldingsTableData } from '../mutualFund/holdings/types';
import { whiteSpaceOnlyRegex } from '../../../utils/regex';
import HoldingsTable from '../mutualFund/holdings/HoldingsTable';
import CustomFilter from './CustomFilter';
import HoldingMoreTable from './customTable/HoldingMoreTable';
import TablePaginationComponent from './customTable/TablePaginationComponent';
import FiveSchemeErrorMessage from '../mutualFund/common/FiveSchemeErrorMessage';
import ValidateDialogBox from '../mutualFund/common/ValidateDialogBox';
import { MAX_SCHEMES_SELECTED } from '../../../utils/constant';


type Props = {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    clientCode: string;
    holdingsData: HoldingsTableData[]
    setHoldingsData: React.Dispatch<React.SetStateAction<HoldingsTableData[]>>
    handleProceed: () => void
};

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    maxWidth: '1000px',
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    borderRadius: '25px',
    boxShadow: 24,
    // p: '35px',
    ':focus': {
        outline: 'none',
    },
    height: 'fit-content',
    maxHeight: '90vh',
    // overflowY: 'auto',
};

const categoriesArray: string[] = [
    "All",
    "Equity",
    "Debt",
    "Hybrid",
    "Others"
]

const tableHeaderData: TableHeaderData[] = [
    {
        id: "schemeName",
        label: "SCHEME",
        align: "left",
        isSortable: true
    },
    {
        id: "units",
        label: "UNITS",
        align: "center",
        isSortable: true
    },
    {
        id: "investedValue",
        label: "INVESTED VALUE",
        align: "center",
        isSortable: true
    },
    {
        id: "marketValue",
        label: "MARKET VALUE",
        align: "center",
        isSortable: true
    },
    {
        id: "amount",
        label: "UNREALISED GAIN/LOSS (%)",
        align: "center",
        isSortable: true
    },
    {
        id: "irr",
        label: "ABSOLUTE RETURN %",
        align: "center",
        isSortable: true
    },
]

const HoldingFundMore = (props: Props) => {
    const { open, setOpen, clientCode, holdingsData, setHoldingsData, handleProceed } = props;
    const theme = useTheme()

    const history = useHistory();
    const { pathname, state } = history.location

    const { selectedSchemes, folio } = (state as {
        selectedSchemes: { folioId: string, scheme: string, id: string }[], folio: {
            folioId: string,
            schemeId: string,
            id: string,
            marketValue: number,
            investedValue: number
        }[]
    }) ?? {}

    const dispatch = useDispatch()

    const [searchText, setSearchText] = useState<string>("")
    const [isHoldingsDataLoading, setHoldingsDataLoading] = useState<boolean>(false)

    const [tableSortingObj, setTableSortingObj] = useState<SortingObj>({
        order: "desc",
        orderBy: "investedValue"
    })
    const [tablePaginationObj, setTablePaginationObj] = useState<PaginationObj>({
        currentPage: 0,
        rowsPerPage: 5,
        totalRows: 0
    })
    const [isFiveSchemesDialogVisible, setFiveSchemesDialogVisible] = useState<boolean>(false)
    const [selectedScheme, setSelectedScheme] = useState<string[]>([])
    const [checkedIds, setCheckedIds] = useState<string[]>([]);
    const [selectedItem, setSelectedItem] = useState<HoldingsTableData[]>([])

    const {
        appliedHoldingsFilters,
        holdingsActiveCategory,
        selectAllHoldingsInfo,
        selectedHoldingsInfo
    } = useSelector((store: RootStateType) => store.investorProfile);

    const { iwappRmId = "" } = useSelector((store: RootStateType) => store.id)

    const { investorRmId = "" } = useSelector((store: RootStateType) => store.sessionData)

    const { role = '' } = useSelector((store: RootStateType) => store.auth);

    const { selectedPortfolio } = useSelector((state: RootStateType) => state.selectedPortfiolio)
    const { label: selectedPortfolioLabel = "", value: selectedPortfolioValue = "" } = selectedPortfolio

    const [initialDataSelectingHolding, setInitialDataSelectingHolding] = useState<Array<any>>(selectAllHoldingsInfo)
    const [initialSelectedHoldingsInfo, setInitialSelectedHoldingsInfo] = useState<Array<any>>(selectedHoldingsInfo)

    const [selectedAddMoreHoldingSchemes, setSelectedAddMoreHoldingSchemes] = useState<Array<{
        id: string;
        uniqueId: string;
    }>>([])

    const debounceSearchText = useDebounce(searchText, 500);

    // console.log('initialDataSelectingHolding', initialDataSelectingHolding)

    const fetchHoldingsData = async ({
        currentCategory = "All",
        selectedAmcIds = [],
        selectedRiskTypes = [],
        searchText = "",
        sortBy = "investedValue",
        sortOrder = "desc",
        currentPage = 1,
        rowsPerPage = 5
    }: FetchHoldingsData) => {
        try {
            setHoldingsDataLoading(true)

            const payload = {
                rmId: `${investorRmId}`,
                clientCode: clientCode,
                portfolioId: selectedPortfolioValue,
                filters: {
                    category: currentCategory,
                    issuerId: selectedAmcIds,
                    riskType: selectedRiskTypes,
                    searchItem: searchText
                },
                sortItem: sortBy,
                order: sortOrder,
                currentPage,
                rowsPerPage
            }

            if ((debounceSearchText.trim().length === 0 || debounceSearchText.trim().length >= 5)
                && !whiteSpaceOnlyRegex.test(debounceSearchText)) {

                const { result, totalLength, message, isSuccess } = await (dispatch(getHoldingsData(payload)) as unknown as Promise<GetHoldingsDataResponseBody>)

                if (isSuccess) {
                    setHoldingsData(result.map((obj) => ({
                        ...obj,
                        schemeName: obj?.schemeName ?? "-",
                        schemeLogo: obj?.schemeLogo ?? "",
                        units: obj?.units ?? 0,
                        investedValue: obj?.investedValue ?? 0,
                        marketValue: obj?.marketValue ?? 0,
                        percentage: {
                            amount: obj?.percentage?.amount ?? 0,
                            percentage: obj?.percentage?.percentage ?? 0
                        },
                        irr: obj?.irr ?? 0,
                        schemeId: obj?.schemeId ?? "",
                        categoryName: obj?.categoryName ?? "",
                        companyName: obj?.companyName ?? "",
                        folioNo: obj?.folioNo ?? "",
                        // checked: selectAllHoldingsInfo.filter((selecetObj) => selecetObj.id === obj.id).length > 0
                        checked: !!selectedAddMoreHoldingSchemes.find((item => item.id === obj.id)),
                    })))

                    setTablePaginationObj(prevState => ({
                        ...prevState,
                        totalRows: totalLength
                    }))
                } else {
                    console.log(message)
                }
            }
        } catch (error) {
            console.log("Error: ", error)
        } finally {
            setHoldingsDataLoading(false)
        }

    }

    useEffect(() => {
        const amcFiltersPayload = appliedHoldingsFilters
            .filter((obj: AppliedHoldingsFilters) => obj.filterType.toLowerCase() === "amc")
            .map((obj: AppliedHoldingsFilters) => `${obj.companyId}`)

        const riskFiltersPayload = appliedHoldingsFilters
            .filter((obj: AppliedHoldingsFilters) => obj.filterType.toLowerCase() === "risk")
            .map((obj: AppliedHoldingsFilters) => `${obj.riskName}`.toLowerCase())

        setTablePaginationObj(prevState => ({ ...prevState, currentPage: 0, rowsPerPage: 5 }))

        fetchHoldingsData({
            currentCategory: holdingsActiveCategory,
            selectedAmcIds: amcFiltersPayload,
            selectedRiskTypes: riskFiltersPayload,
            searchText: debounceSearchText.trim(),
            sortBy: tableSortingObj.orderBy,
            sortOrder: tableSortingObj.order,
            // currentPage: tablePaginationObj.currentPage + 1,
            // rowsPerPage: tablePaginationObj.rowsPerPage
        })
    }, [debounceSearchText])



    const handleCheckboxClick = (schemeId: string, checked: boolean, id: string) => {
        // const checkMoreThenFive = holdingsData.filter((item) => item.checked)
        if (selectAllHoldingsInfo.length === MAX_SCHEMES_SELECTED && checked) {
            setFiveSchemesDialogVisible(true)
            return;
        }

        const currentTimestamp = Date.now()

        if (checked) {

            const selectedSchemeObj = holdingsData.find(obj => obj.id === id)

            setSelectedAddMoreHoldingSchemes((prevState) => [
                ...prevState,
                {
                    id,
                    uniqueId: `${currentTimestamp}-${selectedSchemeObj?.isinCode ?? ""}-${selectedSchemeObj?.folioNo ?? ""}`
                }
            ])

            dispatch(setSelectedHoldingsInfo([
                ...selectedHoldingsInfo,
                {
                    checkedId: id,
                    schemeId,
                    folioNo: selectedSchemeObj?.folioNo ?? "",
                    uniqueId: `${currentTimestamp}-${selectedSchemeObj?.isinCode ?? ""}-${selectedSchemeObj?.folioNo ?? ""}`
                }]))

            dispatch(setSelectedAllHoldingsInfo([
                ...selectAllHoldingsInfo,
                ...holdingsData
                    .filter(obj => obj.id === id)
                    .map(obj => ({
                        ...obj,
                        uniqueId: `${currentTimestamp}-${selectedSchemeObj?.isinCode ?? ""}-${selectedSchemeObj?.folioNo ?? ""}`
                    }))
            ]))
        } else if (!checked) {
            const selectedSchemeObj = selectedAddMoreHoldingSchemes.find(obj => obj.id === id)

            const modifiedSelectedHoldingsInfo = selectedHoldingsInfo.filter((obj) => obj.uniqueId !== selectedSchemeObj?.uniqueId)
            const modifiedSelectedAllHoldingsInfo = selectAllHoldingsInfo.filter((obj) => obj.uniqueId !== selectedSchemeObj?.uniqueId)

            setSelectedAddMoreHoldingSchemes((prevState) => prevState.filter((obj) => obj.id !== id))

            dispatch(setSelectedHoldingsInfo([...modifiedSelectedHoldingsInfo]))
            dispatch(setSelectedAllHoldingsInfo([...modifiedSelectedAllHoldingsInfo]))
        }
        // if (!selectAllHoldingsInfo.find(obj => obj.id === id) && checked) {
        //     const selectedSchemeObj = holdingsData.find(obj => obj.id === id)

        //     dispatch(setSelectedHoldingsInfo([
        //         ...selectedHoldingsInfo,
        //         {
        //             checkedId: id,
        //             schemeId,
        //             folioNo: selectedSchemeObj?.folioNo ?? "",
        //             uniqueId: `${currentTimestamp}-${selectedSchemeObj?.isinCode ?? ""}-${selectedSchemeObj?.folioNo ?? ""}`
        //         }]))
        //     dispatch(setSelectedAllHoldingsInfo([
        //         ...selectAllHoldingsInfo,
        //         ...holdingsData
        //             .filter(obj => obj.id === id)
        //             .map(obj => ({
        //                 ...obj,
        //                 uniqueId: `${currentTimestamp}-${selectedSchemeObj?.isinCode ?? ""}-${selectedSchemeObj?.folioNo ?? ""}`
        //             }))
        //     ]))
        // } else if (selectAllHoldingsInfo.find(obj => obj.id === id) && !checked) {
        //     const modifiedSelectedHoldingsInfo = selectedHoldingsInfo.filter(({ checkedId }) => checkedId !== id)
        //     const modifiedSelectedAllHoldingsInfo = selectAllHoldingsInfo.filter(({ id: checkedId }) => checkedId !== id)

        //     dispatch(setSelectedHoldingsInfo([...modifiedSelectedHoldingsInfo]))
        //     dispatch(setSelectedAllHoldingsInfo([...modifiedSelectedAllHoldingsInfo]))
        // }

        setHoldingsData(prevState => prevState.map(
            item => item.id === id ? { ...item, checked } : item)
        )

    }


    const handleSearchTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchText(event.target.value);
    }

    const handleClearSearch = (e: React.MouseEvent<HTMLButtonElement>) => {
        setSearchText("")
        e.preventDefault()
    }

    const handleCategoryChange = (currentCategory: string) => {
        dispatch(setHoldingsActiveCategory(currentCategory))

        const amcFiltersPayload = appliedHoldingsFilters
            .filter((obj: AppliedHoldingsFilters) => obj.filterType.toLowerCase() === "amc")
            .map((obj: AppliedHoldingsFilters) => `${obj.companyId}`)

        const riskFiltersPayload = appliedHoldingsFilters
            .filter((obj: AppliedHoldingsFilters) => obj.filterType.toLowerCase() === "risk")
            .map((obj: AppliedHoldingsFilters) => `${obj.riskName}`.toLowerCase())

        setTablePaginationObj(prevState => ({ ...prevState, currentPage: 0 }))

        fetchHoldingsData({
            currentCategory,
            selectedAmcIds: amcFiltersPayload,
            selectedRiskTypes: riskFiltersPayload,
            searchText: debounceSearchText.trim(),
            sortBy: tableSortingObj.orderBy,
            sortOrder: tableSortingObj.order,
            rowsPerPage: tablePaginationObj.rowsPerPage
        })
    }


    const handleFilterLeavesClick = async (
        currentFilterType: string,
        currentFilterTypeValue: string,
        currentValue: string
    ) => {
        const modifiedAppliedHoldingsFilters = appliedHoldingsFilters.filter(obj => obj.filterTypeValue !== currentFilterTypeValue)

        dispatch(setAppliedHoldingsFilters(modifiedAppliedHoldingsFilters))

        const amcFiltersPayload = modifiedAppliedHoldingsFilters
            .filter(obj => obj.filterType.toLowerCase() === 'amc')
            .map(obj => `${obj.companyId}`)

        const riskFiltersPayload = modifiedAppliedHoldingsFilters
            .filter(obj => obj.filterType.toLowerCase() === 'risk')
            .map(obj => `${obj.riskName}`.toLowerCase())

        setTablePaginationObj(prevState => ({ ...prevState, currentPage: 0 }))

        fetchHoldingsData({
            currentCategory: holdingsActiveCategory,
            selectedAmcIds: amcFiltersPayload,
            selectedRiskTypes: riskFiltersPayload,
            searchText: debounceSearchText.trim(),
            sortBy: tableSortingObj.orderBy,
            sortOrder: tableSortingObj.order,
            rowsPerPage: tablePaginationObj.rowsPerPage
        })
    }

    const handleSort = (orderBy: string, order: Order) => {
        setTableSortingObj({
            order,
            orderBy
        })

        const amcFiltersPayload = appliedHoldingsFilters
            .filter((obj: AppliedHoldingsFilters) => obj.filterType.toLowerCase() === "amc")
            .map((obj: AppliedHoldingsFilters) => `${obj.companyId}`)

        const riskFiltersPayload = appliedHoldingsFilters
            .filter((obj: AppliedHoldingsFilters) => obj.filterType.toLowerCase() === "risk")
            .map((obj: AppliedHoldingsFilters) => `${obj.riskName}`.toLowerCase())

        fetchHoldingsData({
            currentCategory: holdingsActiveCategory,
            selectedAmcIds: amcFiltersPayload,
            selectedRiskTypes: riskFiltersPayload,
            searchText: debounceSearchText.trim(),
            sortBy: orderBy,
            sortOrder: order,
            currentPage: tablePaginationObj.currentPage + 1,
            rowsPerPage: tablePaginationObj.rowsPerPage
        })
    }

    const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTablePaginationObj(prevState => ({
            ...prevState,
            rowsPerPage: Number(event.target.value),
            currentPage: 0,
        }))

        const amcFiltersPayload = appliedHoldingsFilters
            .filter((obj: AppliedHoldingsFilters) => obj.filterType.toLowerCase() === "amc")
            .map((obj: AppliedHoldingsFilters) => `${obj.companyId}`)

        const riskFiltersPayload = appliedHoldingsFilters
            .filter((obj: AppliedHoldingsFilters) => obj.filterType.toLowerCase() === "risk")
            .map((obj: AppliedHoldingsFilters) => `${obj.riskName}`.toLowerCase())

        setTablePaginationObj(prevState => ({ ...prevState, currentPage: 0 }))

        fetchHoldingsData({
            currentCategory: holdingsActiveCategory,
            selectedAmcIds: amcFiltersPayload,
            selectedRiskTypes: riskFiltersPayload,
            searchText: debounceSearchText.trim(),
            sortBy: tableSortingObj.orderBy,
            sortOrder: tableSortingObj.order,
            rowsPerPage: Number(event.target.value)
        })
    }

    const handlePageChange = (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
        setTablePaginationObj(prevState => ({
            ...prevState,
            currentPage: page
        }))

        const amcFiltersPayload = appliedHoldingsFilters
            .filter((obj: AppliedHoldingsFilters) => obj.filterType.toLowerCase() === "amc")
            .map((obj: AppliedHoldingsFilters) => `${obj.companyId}`)

        const riskFiltersPayload = appliedHoldingsFilters
            .filter((obj: AppliedHoldingsFilters) => obj.filterType.toLowerCase() === "risk")
            .map((obj: AppliedHoldingsFilters) => `${obj.riskName}`.toLowerCase())

        fetchHoldingsData({
            currentCategory: holdingsActiveCategory,
            selectedAmcIds: amcFiltersPayload,
            selectedRiskTypes: riskFiltersPayload,
            searchText: debounceSearchText.trim(),
            sortBy: tableSortingObj.orderBy,
            sortOrder: tableSortingObj.order,
            currentPage: page + 1,
            rowsPerPage: tablePaginationObj.rowsPerPage
        })
    }

    // const handleProceed = () => {

    //     const data = selectAllHoldingsInfo.map(item => ({
    //         folioId: item.folioNo,
    //         scheme: item.schemeId,
    //         id: item.id,
    //         marketValue: item.marketValue,
    //         investedValue: item.investedValue
    //     }))

    //     const checkedIds = data.map((obj) => obj.scheme)

    //     dispatch(setSelectedHoldingsIds([...selectedScheme]))
    //     dispatch(setCheckedHoldingSchemes([...checkedIds]))
    //     if (pathname.split('/')[pathname.split('/').length - 1] === 'invest-more') {
    //         history.replace({
    //             state: ({
    //                 clientCode,
    //                 selectedSchemes: [...data],
    //                 folio: data.map((obj) => ({
    //                     folioId: obj.folioId,
    //                     schemeId: obj.scheme,
    //                     id: obj.id,
    //                     marketValue: obj.marketValue,
    //                     investedValue: obj.investedValue
    //                 }))
    //             })
    //         })

    //     } else {

    //         history.replace({ state: ({ selectedSchemes: [...data], clientCode }) })
    //     }
    //     setOpen(false)
    // }

    const handleCloseFiveSchemesDialog = () => {
        setFiveSchemesDialogVisible(false)
    }

    const handleClose = () => {
        dispatch(setSelectedAllHoldingsInfo([...initialDataSelectingHolding]))
        dispatch(setSelectedHoldingsInfo([...initialSelectedHoldingsInfo]))
        setOpen(false)
    }

    return (
        <>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby={'All Schemes'}
                aria-describedby={'All Schemes'}>
                <Box sx={style}>
                    <Box
                        sx={(theme: Theme) => ({
                            backgroundColor: theme.palette.common.white,
                            boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                            borderRadius: "25px",
                            padding: "35px"
                        })}
                    >
                        <Grid
                            container
                            sx={{
                                justifyContent: "space-between",
                                alignItems: "flex-start",
                            }}
                        >
                            <Grid
                                item
                                xs={6}
                            >
                                <Typography
                                    variant="h2"
                                    sx={(theme: Theme) => ({
                                        color: theme.palette.text.primary,
                                    })}
                                >
                                    Investments
                                </Typography>
                            </Grid>
                            <Grid
                                item
                                container
                                xs={6}
                                sx={{
                                    columnGap: "25px",
                                    justifyContent: "flex-end",
                                    alignItems: "center"
                                }}
                            >
                                <Box maxWidth={'225px'} width={'100%'}>
                                    <CustomeButton lookType={'contained'} btnText={'Proceed'} disabled={isHoldingsDataLoading} onClick={handleProceed} />

                                </Box>
                            </Grid>
                        </Grid>
                        <Box sx={{
                            marginTop: "20px",
                            display: "flex",
                            flexDirection: "column",
                            rowGap: "5px"

                        }}>
                            <TextField
                                autoFocus
                                fullWidth
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                sx={{ display: searchText.length > 0 ? 'inline-flex' : 'none' }}
                                                onMouseDown={handleClearSearch}
                                            >
                                                <DialogCloseIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                    sx: (theme: Theme) => ({
                                        borderRadius: '8px',
                                        height: '50px',
                                        border: `1px solid ${theme.palette.text.secondary}B2`,
                                        '& fieldset': {
                                            border: 'none',
                                        },
                                        '& input': {
                                            paddingLeft: '10px',
                                            ...theme.typography.body_500,
                                            color: theme.palette.text.primary,
                                            '::placeholder': {
                                                ...theme.typography.subtitle_400,
                                                color: theme.palette.text.secondary,
                                                opacity: 1,
                                            },
                                        },
                                    }),
                                }}
                                value={searchText}
                                placeholder="Search"
                                onChange={handleSearchTextChange}
                            />
                            <Typography
                                variant="overline_600"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.grey[500],
                                    marginTop: "5px"
                                })}
                            >
                                Minimum 5 characters required
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                marginTop: "20px",
                                display: "flex",
                                gap: "10px",
                                overflow: 'auto'
                            }}
                        >
                            {categoriesArray.map((category) => (
                                <Box
                                    key={category}
                                    sx={(theme: Theme) => ({
                                        padding: "3px 15px",
                                        borderRadius: "7px",
                                        backgroundColor: holdingsActiveCategory === category ? theme.palette.primary[500] : theme.palette.common.white,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        cursor: "pointer",
                                    })}
                                    onClick={() => handleCategoryChange(category)}
                                >
                                    <Typography
                                        variant="body_500"
                                        sx={(theme: Theme) => ({
                                            color: holdingsActiveCategory === category ? theme.palette.textDark.primary : theme.palette.text.secondary
                                        })}
                                    >
                                        {category}
                                    </Typography>
                                </Box>
                            ))}
                        </Box>
                        <Box
                            sx={{
                                marginTop: "25px",
                                display: appliedHoldingsFilters.length ? "flex" : "none",
                                gap: "15px",
                                flexWrap: "wrap",
                            }}
                        >
                            {appliedHoldingsFilters.map((obj) => (
                                <Button
                                    key={obj.filterTypeValue}
                                    variant="contained"
                                    startIcon={<CrossIcon />}
                                    onClick={() => handleFilterLeavesClick(
                                        obj.filterType,
                                        obj.filterTypeValue,
                                        obj.value
                                    )}
                                    sx={(theme: Theme) => ({
                                        borderRadius: "61px",
                                        backgroundColor: theme.palette.primary[50],
                                        padding: "7px 16px",
                                        color: theme.palette.text.primary,
                                        whiteSpace: "nowrap",
                                        boxShadow: "none",
                                        ...theme.typography.subtitle_400,
                                        "& .MuiButton-startIcon": {
                                            paddingTop: "2px"
                                        },
                                        "&:hover": {
                                            backgroundColor: theme.palette.primary[100],
                                            boxShadow: "none"
                                        },
                                        "&.Mui-disabled": {
                                            opacity: 0.5
                                        }
                                    })}
                                    disabled={isHoldingsDataLoading}
                                >
                                    {obj.label}
                                </Button>
                            ))}
                        </Box>
                        <Box
                            sx={{ marginTop: "25px", overflowY: 'auto', maxHeight: '50vh' }}
                        >
                            <CustomTable
                                isLoading={isHoldingsDataLoading}
                                tableBody={
                                    <HoldingMoreTable
                                        data={holdingsData}
                                        onCheckboxClick={handleCheckboxClick}
                                    />
                                }
                                tableData={holdingsData}
                                tableBodyLoaderRowCustomStyles={{
                                    '& td:first-of-type': {
                                        paddingLeft: "0px"
                                    },
                                }}
                                tableHeadRowCustomStyles={{
                                    '& th:first-of-type': {
                                        paddingLeft: "0px"
                                    }
                                }}
                                tableBodyCustomStyles={{
                                    '& tr:last-child td': {
                                        border: 0
                                    },
                                }}
                                tableHeaderData={tableHeaderData}
                                handleSort={handleSort}
                                isPaginationVisible={false}
                                order={tableSortingObj.order}
                                orderBy={tableSortingObj.orderBy}
                                loadingRowsNum={5}
                                tableDataCount={tablePaginationObj.totalRows}
                                rowsPerPage={tablePaginationObj.rowsPerPage}
                                rowsPerPageOptions={[5, 10, 15, 20]}
                                handleRowsPerPageChange={handleRowsPerPageChange}
                                handlePageChange={handlePageChange}
                                currentPage={tablePaginationObj.currentPage}

                            />
                        </Box>
                        <TablePaginationComponent
                            tableDataCount={tablePaginationObj.totalRows}
                            handlePageChange={handlePageChange}
                            handleRowsPerPageChange={handleRowsPerPageChange}
                            rowsPerPage={tablePaginationObj.rowsPerPage}
                            rowsPerPageOptions={[5, 10, 15, 20]}
                            currentPage={tablePaginationObj.currentPage}
                        />
                    </Box >

                </Box>
            </Modal>
            <FiveSchemeErrorMessage handleCloseFiveSchemesDialog={handleCloseFiveSchemesDialog} isFiveSchemesDialogVisible={isFiveSchemesDialogVisible} />
        </>
    );
};

export default HoldingFundMore;
